import { createContext, useContext } from 'react';

export type DescriptionConfig = object;

const defaultContext = {};

export const DescriptionContext = createContext<DescriptionConfig>(defaultContext);

export const useDescriptionContext = (): DescriptionConfig => useContext<DescriptionConfig>(DescriptionContext);
